import React from 'react'
import { Route } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from './dux'
import Slider from '../../shared/components/Slider/Slider'
import Home from '../home/screens/Home/Home'
import Question from '../questions/screens/Questions/Questions'

const PageRoute = ({ ...rest }) => {
  const page = useSelector(state => state.routing.page)
  const dispatch = useDispatch()
  const setPage = routePage => dispatch(actions.setPage(routePage))
  const routes = (props) => {
    const mergedProps = { ...props, page, setPage }
    switch (page) {
    case 0:
      return <Home {...mergedProps} />
    case 1:
      return <Question {...mergedProps} />
    default:
      return ''
    }
  }

  return (
    <Route
      {...rest}
      render={props => (
        <Slider
          page={page}
          type="main"
          className="main-slider"
        >
          {routes(props)}
        </Slider>
      )}
    />
  )
}

export default PageRoute
